import { Injectable, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserInteractionLoggerService implements OnDestroy {
  private isActive = false;

  initialize(): void {
    if (typeof document === 'undefined' || this.isActive) return;

    document.addEventListener('click', this.handleClick.bind(this), true);
    document.addEventListener('input', this.handleInput.bind(this), true);
    document.addEventListener('change', this.handleChange.bind(this), true);

    this.isActive = true;
  }

  shutdown(): void {
    if (!this.isActive) return;

    document.removeEventListener('click', this.handleClick.bind(this), true);
    document.removeEventListener('input', this.handleInput.bind(this), true);
    document.removeEventListener('change', this.handleChange.bind(this), true);

    this.isActive = false;
  }

  ngOnDestroy(): void {
    this.shutdown();
  }

  private handleClick(event: Event): void {
    const target = event.target as HTMLElement;
    
    // Ignorar elementos con data-log-ignore
    if (target.closest('[data-log-ignore]')) return;

    const info = {
      tipo: 'CLICK',
      timestamp: new Date().toISOString(),
      elemento: target.tagName.toLowerCase(),
      componente: this.getComponentName(target),
      texto: this.getElementText(target),
      id: target.id || undefined,
      clases: Array.from(target.classList),
      ruta: globalThis.location.pathname
    };

    console.log('👆 INTERACCIÓN:', info);
  }

  private handleInput(event: Event): void {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    
    if (target.closest('[data-log-ignore]') || target.type === 'password') return;

    const info = {
      tipo: 'INPUT',
      timestamp: new Date().toISOString(),
      elemento: target.tagName.toLowerCase(),
      inputType: target.type,
      nombre: target.name || target.getAttribute('formcontrolname') || undefined,
      valor: target.value.substring(0, 50),
      ruta: globalThis.location.pathname
    };

    console.log('⌨️  INTERACCIÓN:', info);
  }

  private handleChange(event: Event): void {
    const target = event.target as HTMLInputElement | HTMLSelectElement;
    
    if (target.closest('[data-log-ignore]')) return;

    const info = {
      tipo: 'CHANGE',
      timestamp: new Date().toISOString(),
      elemento: target.tagName.toLowerCase(),
      nombre: target.name || target.getAttribute('formcontrolname') || undefined,
      valor: target.value,
      ruta: globalThis.location.pathname
    };

    console.log('🔄 INTERACCIÓN:', info);
  }

  private getComponentName(element: HTMLElement): string | undefined {
    const component = element.closest('[class*="app-"], app-capital-button, app-primary-button, app-capital-input, app-capital-select');
    return component?.tagName.toLowerCase();
  }

  private getElementText(element: HTMLElement): string | undefined {
    // Para botones, buscar el título o texto principal
    if (element.tagName === 'BUTTON' || element.classList.contains('capital-button')) {
      const titleElement = element.querySelector('.title, h1, h2, h3, p');
      if (titleElement?.textContent) {
        return titleElement.textContent.trim();
      }
    }

    const text = element.textContent?.trim();
    return text && text.length > 0 && text.length < 100 ? text : undefined;
  }
}
